import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
// import Report from './views/sales/Report.vue'

Vue.use(Router)

export default new Router({
  mode: 'history', // HTML5 history モード
  scrollBehavior() {
    // routerでの画面遷移時の座標を必ずx:0, y:0
    // see https://router.vuejs.org/ja/guide/advanced/scroll-behavior.html
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/sales/SalesReport',
      name: 'sales/SalesReport',
      component: () => import('./views/sales/SalesReport.vue'),
      meta: {
        title: '売上報告',
        titleKey: 'sales-report',
        desc: ''
      }
    },
    {
      path: '/sales/SalesReportConfirm',
      name: 'sales/SalesReportConfirm',
      component: () => import('./views/sales/SalesReportConfirm.vue'),
      meta: {
        title: '売上報告確認',
        titleKey: 'sales-report-confirm',
        desc: ''
      }
    },
    {
      path: '/sales/StoreStockManagement',
      name: 'sales/StoreStockManagement',
      component: () => import('./views/sales/StoreStockManagement.vue'),
      meta: {
        title: '店舗在庫管理',
        titleKey: 'store-stock-management',
        desc: ''
      }
    },
    {
      path: '/sales/ReturnItems',
      name: 'sales/ReturnItems',
      component: () => import('./views/sales/ReturnItems.vue'),
      meta: {
        title: '返品処理',
        titleKey: 'sales-returnItems',
        desc: ''
      }
    },
    {
      path: '/sales/Stocktaking',
      name: 'sales/Stocktaking',
      component: () => import('./views/sales/Stocktaking.vue'),
      meta: {
        title: '店舗在庫棚卸',
        titleKey: 'sales-stocktaking',
        desc: ''
      }
    },
    {
      path: '/sales/StocktakingConfirm',
      name: 'sales/StocktakingConfirm',
      component: () => import('./views/sales/StocktakingConfirm.vue'),
      meta: {
        title: '店舗在庫棚卸確定',
        titleKey: 'sales-stocktaking-confirm',
        desc: ''
      }
    },
    {
      path: '/admin/WarehouseMaintenance',
      name: 'admin/WarehouseMaintenance',
      component: () => import('./views/admin/WarehouseMaintenance.vue'),
      meta: {
        title: '倉庫データメインテナンス',
        titleKey: 'admin-warehouse-maintenance',
        desc: ''
      }
    },
    {
      path: '/admin/WarehouseStockManagement',
      name: 'admin/WarehouseStockManagement',
      component: () => import('./views/admin/WarehouseStockManagement.vue'),
      meta: {
        title: '倉庫棚卸在庫管理',
        titleKey: 'admin-warehouse-stock-management',
        desc: ''
      }
    },
    {
      path: '/admin/WarehouseStockManagementDetail',
      name: 'admin/WarehouseStockManagementDetail',
      component: () => import('./views/admin/WarehouseStockManagementDetail.vue'),
      meta: {
        title: '倉庫棚卸在庫詳細',
        titleKey: 'admin-warehouse-stock-management-detail',
        desc: ''
      }
    },
    {
      path: '/admin/WarehouseRealtimeStocktaking',
      name: 'admin/WarehouseRealtimeStocktaking',
      component: () => import('./views/admin/WarehouseRealtimeStocktaking.vue'),
      meta: {
        title: '千葉倉庫在庫確認',
        titleKey: 'admin-warehouse-stock-status',
        desc: ''
      }
    },
    {
      path: '/admin/ShippingHistory',
      name: 'admin/ShippingHistory',
      component: () => import('./views/admin/ShippingHistory.vue'),
      meta: {
        title: '千葉出荷履歴確認CSV',
        titleKey: 'admin-shipping-history',
        desc: ''
      }
    },
    {
      path: '/admin/WarehouseStocktaking',
      name: 'admin/WarehouseStocktaking',
      component: () => import('./views/admin/WarehouseStocktaking.vue'),
      meta: {
        title: '倉庫在庫棚卸',
        titleKey: 'admin-warehouse-stocktaking',
        desc: ''
      }
    },
    {
      path: '/admin/WarehouseStocktakingConfirm',
      name: 'admin/WarehouseStocktakingConfirm',
      component: () => import('./views/admin/WarehouseStocktakingConfirm.vue'),
      meta: {
        title: '倉庫在庫棚卸確定',
        titleKey: 'admin-warehouse-stocktaking-confirm',
        desc: ''
      }
    },
    {
      path: '/admin/stockManagement',
      name: 'admin/stockManagement',
      component: () => import('./views/admin/StockManagement.vue'),
      meta: {
        title: '棚卸在庫一覧',
        titleKey: 'admin-stockManagement',
        desc: ''
      }
    },
    {
      path: '/admin/stockManagementDetail',
      name: 'admin/stockManagementDetail',
      component: () => import('./views/admin/StockManagementDetail.vue'),
      meta: {
        title: '棚卸在庫詳細',
        titleKey: 'admin-stockManagementDetail',
        desc: ''
      }
    },
    {
      path: '/admin/stocktakingRegist',
      name: 'admin/stocktakingRegist',
      component: () => import('./views/admin/StocktakingRegist.vue'),
      meta: {
        title: '棚卸在庫詳細',
        titleKey: 'admin-stocktakingRegist',
        desc: ''
      }
    },
    {
      path: '/admin/report-confirm',
      name: 'admin/report-confirm',
      component: () => import('./views/admin/ReportConfirm.vue'),
      meta: {
        title: '売上報告確認',
        titleKey: 'admin-report-confirm',
        desc: ''
      }
    },
    {
      path: '/admin/report-regist',
      name: 'admin/report-regist',
      component: () => import('./views/admin/ReportRegist.vue'),
      meta: {
        title: '売上報告登録',
        titleKey: 'admin-report-confirm',
        desc: ''
      }
    },
    {
      path: '/admin/incentive-calculation',
      name: 'admin/incentive-calculation',
      component: () => import('./views/admin/IncentiveCalculation.vue'),
      meta: {
        title: 'インセンティブ計算',
        titleKey: 'admin-incentive-calculation',
        desc: ''
      }
    },
    {
      path: '/admin/sales-excel-upload',
      name: 'admin/sales-excel-upload',
      component: () => import('./views/admin/SalesExcelUpload.vue'),
      meta: {
        title: '販売実績アップロード',
        titleKey: 'admin-sales-excel-upload',
        desc: ''
      }
    },
    {
      path: '/admin/sales-excel-upload-analysis',
      name: 'admin/sales-excel-upload-analysis',
      component: () => import('./views/admin/SalesExcelUploadAnalysis.vue'),
      meta: {
        title: '販売実績アップロード結果',
        titleKey: 'admin-sales-excel-upload-analysis',
        desc: ''
      }
    },
    {
      path: '/admin/partner-store-mapping-maintenance',
      name: 'admin/partner-store-mapping-maintenance',
      component: () => import('./views/admin/PartnerStoreMappingMaintenance.vue'),
      meta: {
        title: '取引先店舗のマッピング',
        titleKey: 'admin-partner-store-mapping-maintenance',
        desc: ''
      }
    },
    {
      path: '/admin/partner-store-mapping-regist',
      name: 'admin/partner-store-mapping-regist',
      component: () => import('./views/admin/PartnerStoreMappingRegist.vue'),
      meta: {
        title: '取引先店舗のマッピング登録',
        titleKey: 'admin-partner-store-mapping-regist',
        desc: ''
      }
    },
    {
      path: '/sales/new-user-login',
      name: 'sales/new-user-login',
      component: () => import('./views/sales/NewUserLogin.vue'),
      alias: '/',
      meta: {
        title: '販売員ログイン',
        titleKey: 'sales-user-login',
        desc: ''
      }
    },
    {
      path: '/sales/new-user-menu',
      name: 'sales/new-user-menu',
      component: () => import('./views/sales/NewUserMenu.vue'),
      meta: {
        title: '販売員メニュー',
        titleKey: 'sales-user-menu',
        desc: ''
      }
    },
    {
      path: '/admin/password-change',
      name: 'admin/password-change',
      component: () => import('./views/admin/PasswordChange.vue'),
      meta: {
        title: '初期パスワード変更',
        titleKey: 'admin-password-change',
        desc: ''
      }
    },
    {
      path: '/admin/new-admin-login',
      name: 'admin/new-admin-login',
      component: () => import('./views/admin/NewAdminLogin.vue'),
      alias: '/admin-login',
      meta: {
        title: '管理者ログイン',
        titleKey: 'admin-admin-login',
        desc: ''
      }
    },
    {
      path: '/admin/new-admin-menu',
      name: 'admin/new-admin-menu',
      component: () => import('./views/admin/NewAdminMenu.vue'),
      meta: {
        title: '管理者メニュー',
        titleKey: 'admin-admin-menu',
        desc: ''
      }
    },
    {
      path: '/admin/new-item-category',
      name: 'admin/new-item-category',
      component: () => import('./views/admin/NewItemCategory.vue'),
      meta: {
        title: '商品カテゴリメンテナンス',
        titleKey: 'admin-item-category',
        desc: ''
      }
    },
    {
      path: '/admin/new-item-maintenance',
      name: 'admin/new-item-maintenance',
      component: () => import('./views/admin/NewItemMaintenance.vue'),
      meta: {
        title: '商品データメンテナンス',
        titleKey: 'admin-item-maintenance',
        desc: ''
      }
    },
    {
      path: '/admin/new-item-regist',
      name: 'admin/new-item-regist',
      component: () => import('./views/admin/NewItemRegist.vue'),
      meta: {
        title: '商品データ登録',
        titleKey: 'admin-item-regist',
        desc: ''
      }
    },
    {
      path: '/admin/new-user-regist',
      name: 'admin/new-user-regist',
      component: () => import('./views/admin/NewUserRegist.vue'),
      meta: {
        title: '従業員データ登録',
        titleKey: 'admin-user-regist',
        desc: ''
      }
    },
    {
      path: '/admin/new-user-update',
      name: 'admin/new-user-update',
      component: () => import('./views/admin/NewUserUpdate.vue'),
      meta: {
        title: '従業員データ更新',
        titleKey: 'admin-user-update',
        desc: ''
      }
    },
    {
      path: '/admin/items/:itemCode',
      name: 'admin_items_update',
      component: () => import('./views/admin/NewItemRegist.vue'),
      meta: {
        title: '商品データ更新',
        titleKey: 'admin-items-itemCode',
        desc: ''
      }
    },
    {
      path: '/sales/new-order-send',
      name: 'sales/new-order-send',
      component: () => import('./views/sales/NewOrderSend.vue'),
      meta: {
        title: '発注依頼',
        titleKey: 'sales-order-send',
        desc: '',
        props: true
      }
    },
    {
      path: '/sales/new-order-send-confirm',
      name: 'sales/new-order-send-confirm',
      component: () => import('./views/sales/NewOrderSendConfirm.vue'),
      meta: {
        title: '発注依頼確認',
        titleKey: 'sales-order-send-confirm',
        desc: '',
        props: true
      }
    },
    {
      path: '/sales/new-order-send-by-image',
      name: 'sales/new-order-send-by-image',
      component: () => import('./views/sales/NewOrderSendByImage.vue'),
      meta: {
        title: '発注依頼送信',
        titleKey: 'sales-order-send-by-image',
        desc: '',
        props: true
      }
    },
    {
      path: '/admin/new-item-send-by-image',
      name: 'admin/new-item-send-by-image',
      component: () => import('./views/admin/NewItemSendByImage.vue'),
      meta: {
        title: '商品イメージ送信',
        titleKey: 'sales-item-send-by-image',
        desc: '',
        props: true
      }
    },
    {
      path: '/admin/new-maker-maintenance',
      name: 'admin/new-maker-maintenance',
      component: () => import('./views/admin/NewMakerMaintenance.vue'),
      meta: {
        title: '製造会社メンテナンス',
        titleKey: 'admin-maker-maintenance',
        desc: ''
      }
    },
    {
      path: '/admin/makers/new',
      name: 'admin/makers/new',
      component: () => import('./views/admin/NewMakerRegist.vue'),
      meta: {
        title: '製造会社データ登録',
        titleKey: 'admin-makers-new',
        desc: ''
      }
    },
    {
      path: '/admin/makers/:makerId',
      name: 'admin_makers_update',
      component: () => import('./views/admin/NewMakerRegist.vue'),
      meta: {
        title: '製造会社データ更新',
        titleKey: 'admin-makers-makerId',
        desc: ''
      }
    },
    {
      path: '/admin/order-mail-target-store',
      name: 'admin/order-mail-target-store',
      component: () => import('./views/admin/OrderMailTargetStore.vue'),
      meta: {
        title: '事前連絡店舗一覧',
        titleKey: 'admin-order-mail-target-store',
        desc: ''
      }
    },
    {
      path: '/admin/order-mail-target-store/new',
      name: 'admin/order-mail-target-store/new',
      component: () => import('./views/admin/OrderMailTargetStoreRegist.vue'),
      meta: {
        title: '事前連絡店舗登録',
        titleKey: 'admin-order-mail-target-store-new',
        desc: ''
      }
    },
    {
      path: '/admin/order-mail-target-store/:storeCode',
      name: 'admin_order_mail_target_store_update',
      component: () => import('./views/admin/OrderMailTargetStoreRegist.vue'),
      meta: {
        title: '事前連絡店舗更新',
        titleKey: 'admin-order-mail-target-store-update',
        desc: ''
      }
    },


    {
      path: '/admin/order-mail-receiver',
      name: 'admin/order-mail-receiver',
      component: () => import('./views/admin/OrderMailReceiver.vue'),
      meta: {
        title: '事前連絡店舗メール受信者一覧',
        titleKey: 'admin-order-mail-receiver',
        desc: ''
      }
    },
    {
      path: '/admin/order-mail-receiver/new',
      name: 'admin/order-mail-receiver/new',
      component: () => import('./views/admin/OrderMailReceiverRegist.vue'),
      meta: {
        title: '事前連絡店舗メール受信者登録',
        titleKey: 'admin-order-mail-receiver-new',
        desc: ''
      }
    },
    {
      path: '/admin/order-mail-receiver/:email',
      name: 'admin_order_mail_receiver_update',
      component: () => import('./views/admin/OrderMailReceiverRegist.vue'),
      meta: {
        title: '事前連絡店舗メール受信者更新',
        titleKey: 'admin-order-mail-receiver-update',
        desc: ''
      }
    },



    {
      path: '/admin/new-supplier-maintenance',
      name: 'admin/new-supplier-maintenance',
      component: () => import('./views/admin/NewSupplierMaintenance.vue'),
      meta: {
        title: '取引先データメンテナンス',
        titleKey: 'admin-supplier-maintenance',
        desc: ''
      }
    },
    {
      path: '/admin/suppliers/new',
      name: 'admin/suppliers/new',
      component: () => import('./views/admin/NewSupplierRegist.vue'),
      meta: {
        title: '取引先データ登録',
        titleKey: 'admin-suppliers-new',
        desc: ''
      }
    },
    {
      path: '/admin/suppliers/:supplierCode',
      name: 'admin_suppliers_update',
      component: () => import('./views/admin/NewSupplierRegist.vue'),
      meta: {
        title: '取引先データ更新',
        titleKey: 'admin-suppliers-supplierCode',
        desc: ''
      }
    },
    {
      path: '/admin/new-store-maintenance',
      name: 'admin/new-store-maintenance',
      component: () => import('./views/admin/NewStoreMaintenance.vue'),
      meta: {
        title: '店舗データメンテナンス',
        titleKey: 'admin-store-maintenance',
        desc: ''
      }
    },
    {
      path: '/admin/stores/:storeCode',
      name: 'admin_stores_update',
      component: () => import('./views/admin/NewStoreRegist.vue'),
      meta: {
        title: '店舗データ更新',
        titleKey: 'admin-stores-storecode',
        desc: ''
      }
    },
    {
      path: '/admin/stores/new',
      name: 'admin/stores/new',
      component: () => import('./views/admin/NewStoreRegist.vue'),
      meta: {
        title: '店舗データ登録',
        titleKey: 'admin-stores-new',
        desc: ''
      }
    },    
    {
      path: '/admin/new-user-upload',
      name: 'admin/new-user-upload',
      component: () => import('./views/admin/NewUserUpload.vue'),
      meta: {
        title: '従業員データ一覧',
        titleKey: 'admin-user-upload',
        desc: ''
      }
    },
    {
      path: '/admin/new-brand-maintenance',
      name: 'admin/new-brand-maintenance',
      component: () => import('./views/admin/NewBrandMaintenance.vue'),
      meta: {
        title: 'ブランド名メンテナンス',
        titleKey: 'admin-brand-maintenance',
        desc: ''
      }
    },
    {
      path: '/admin/new-businessContact',
      name: 'admin/new-businessContact',
      component: () => import('./views/admin/NewBusinessContact.vue'),
      meta: {
        title: '業務連絡登録',
        titleKey: 'admin-businessContact',
        desc: ''
      }
    },
    {
      path: '/admin/new-order-confirm',
      name: 'admin/new-order-confirm',
      component: () => import('./views/admin/NewOrderConfirm.vue'),
      meta: {
        title: '発注依頼確認',
        titleKey: 'admin-order-confirm',
        desc: ''
      }
    },
    {
      path: '/admin/new-order-accept',
      name: 'admin/new-order-accept',
      component: () => import('./views/admin/NewOrderAccept.vue'),
      meta: {
        title: '発注依頼確認',
        titleKey: 'admin-order-accept',
        desc: ''
      }
    },
    {
      path: '/admin/supplier-brand-maintenance',
      name: 'admin/supplier-brand-maintenance',
      component: () => import('./views/admin/SupplierBrandMaintenance.vue'),
      meta: {
        title: '取引先・ブランド関連メンテナンス',
        titleKey: 'admin-supplier-brand-maintenance',
        desc: ''
      }
    },
    {
      path: '/admin/delivery-slip',
      name: 'admin/delivery-slip',
      component: () => import('./views/admin/DeliverySlip.vue'),
      meta: {
        title: '納品書出力',
        titleKey: 'admin-delivery-slip',
        desc: '',
        nonDispHeader: true
      }
    },
    {
      path: '/admin/display-store-items-list',
      name: 'admin/display-store-items-list',
      component: () => import('./views/admin/DisplayStoreItemsList.vue'),
      meta: {
        title: '発注画面表示商品一覧',
        titleKey: 'admin-display-store-items-list',
        desc: '発注画面表示商品一覧'
      }
    },
    {
      path: '/admin/display-store-items-regist',
      name: 'admin-display-store-items-regist',
      component: () => import('./views/admin/DisplayStoreItemsRegist.vue'),
      meta: {
        title: '発注画面表示商品一括登録',
        titleKey: 'admin-display-store-items-regist',
        desc: '発注画面表示商品一括登録'
      }
    }, 
    {
      path: '/admin/display-store-items-list2',
      name: 'admin/display-store-items-list2',
      component: () => import('./views/admin/DisplayStoreItemsList2.vue'),
      meta: {
        title: '店舗一覧',
        titleKey: 'admin-display-store-items-list2',
        desc: '店舗一覧'
      }
    },   
    {
      path: '/admin/display-store-items-regist2',
      name: 'admin-display-store-items-regist2',
      component: () => import('./views/admin/DisplayStoreItemsRegist2.vue'),
      meta: {
        title: '発注画面表示商品一括登録',
        titleKey: 'admin-display-store-items-regist',
        desc: '発注画面表示商品一括登録'
      }
    },
    {
      path: '/admin/display-store-items-delete2',
      name: 'admin-display-store-items-delete2',
      component: () => import('./views/admin/DisplayStoreItemsDelete2.vue'),
      meta: {
        title: '発注画面表示商品一括削除',
        titleKey: 'admin-display-store-items-delete',
        desc: '複数店舗に複数表示商品削除'
      }
    },
    {
      path: '/admin/display-store-items-list3',
      name: 'admin/display-store-items-list3',
      component: () => import('./views/admin/DisplayStoreItemsList3.vue'),
      meta: {
        title: '商品一覧',
        titleKey: 'admin-store-item-list',
        desc: '商品一覧'
      }
    },   
    {
      path: '/admin/display-store-items-regist3',
      name: 'admin-display-store-items-regist3',
      component: () => import('./views/admin/DisplayStoreItemsRegist3.vue'),
      meta: {
        title: '発注画面表示商品一括登録',
        titleKey: 'admin-display-store-items-regist',
        desc: '発注画面表示商品一括登録'
      }
    },
    {
      path: '/admin/display-store-items-delete3',
      name: 'admin-display-store-items-delete3',
      component: () => import('./views/admin/DisplayStoreItemsDelete3.vue'),
      meta: {
        title: '発注画面表示商品一括削除',
        titleKey: 'admin-display-store-items-delete',
        desc: '複数店舗に複数表示商品削除'
      }
    },
    {
      path: '/admin/display-store-items-detail2/:storeCode',
      name: 'admin/display-store-items-detail2',
      component: () => import('./views/admin/DisplayStoreItemsDetail2.vue'),
      meta: {
        title: '店舗発注画面非表示商品一覧',
        titleKey: 'admin-display-store-items-detail',
        desc: '店舗発注画面非表示商品一覧'
      }
    },
    {
      path: '/admin/store-item-list',
      name: 'admin/store-item-list',
      component: () => import('./views/admin/StoreItemList.vue'),
      meta: {
        title: '商品一覧',
        titleKey: 'admin-store-item-list',
        desc: '商品一覧'
      }
    },
    {
      path: '/admin/store-item-multi-regist',
      name: 'admin-store-item-multi-regits',
      component: () => import('./views/admin/StoreItemMultiRegist.vue'),
      meta: {
        title: '商品一括登録',
        titleKey: 'admin-store-item-regist',
        desc: '複数店舗に複数商品登録'
      }
    },
    {
      path: '/admin/store-item-multi-delete',
      name: 'admin-store-item-multi-delete',
      component: () => import('./views/admin/StoreItemMultiDelete.vue'),
      meta: {
        title: '商品一括削除',
        titleKey: 'admin-store-item-delete',
        desc: '複数店舗に複数商品削除'
      }
    },
    {
      path: '/admin/agency-order-upload',
      name: 'admin/agency-order-upload',
      component: () => import('./views/admin/CsvAgencyOrderUpload.vue'),
      meta: {
        title: '一括発注登録（代理店）',
        titleKey: 'admin-group-store-order-upload',
        desc: '一括発注登録（代理店）'
      }
    },
    {
      path: '/admin/store-standard-stock-management',
      name: 'admin/store-standard-stock-management',
      component: () => import('./views/admin/StoreStandardStockManagement.vue'),
      meta: {
        title: '店舗在庫管理',
        titleKey: 'admin-store-standard-stock-management',
        desc: ''
      }
    },
    {
      path: '/admin/store-compare-stocktaking',
      name: 'admin/store-compare-stocktaking',
      component: () => import('./views/admin/StoreCompareStocktaking.vue'),
      meta: {
        title: '店舗在庫比較',
        titleKey: 'admin-store-compare-stocktaking',
        desc: 'Compare'
      }
    },
    {
      path: '/admin/store-compare-stocktaking-detail',
      name: 'admin/store-compare-stocktaking-detail',
      component: () => import('./views/admin/StoreCompareStocktakingDetail.vue'),
      meta: {
        title: '店舗在庫比較詳細',
        titleKey: 'admin-store-compare-stocktaking-detail',
        desc: ''
      }
    },
    {
      path: '/admin/store-standard-stock-regist',
      name: 'admin/store-standard-stock-regist',
      component: () => import('./views/admin/StoreStandardStockRegist.vue'),
      meta: {
        title: '店舗基準在庫登録',
        titleKey: 'admin-store-standard-stock-regist',
        desc: ''
      }
    },
    {
      path: '/admin/ocr-user-store-mapping',
      name: 'admin/ocr-user-store-mapping',
      component: () => import('./views/admin/OcrUserStoreMapping.vue'),
      meta: {
        title: 'ユーザ・店舗マッピング',
        titleKey: 'admin-ocr-user-store-mapping',
        desc: ''
      }
    },
    {
      path: '/admin/ocr-user-store-mapping/new',
      name: 'admin/ocr-user-store-mapping/new',
      component: () => import('./views/admin/OcrUserStoreMappingRegist.vue'),
      meta: {
        title: 'ユーザ・店舗マッピング登録',
        titleKey: 'admin-ocr-user-store-mapping-new',
        desc: ''
      }
    },

    {
      path: '/admin/order-mail-target-store',
      name: 'admin/order-mail-target-store',
      component: () => import('./views/admin/OrderMailTargetStore.vue'),
      meta: {
        title: '事前連絡店舗一覧',
        titleKey: 'admin-order-mail-target-store',
        desc: ''
      }
    },
    {
      path: '/admin/order-mail-target-store/new',
      name: 'admin/order-mail-target-store/new',
      component: () => import('./views/admin/OrderMailTargetStoreRegist.vue'),
      meta: {
        title: '事前連絡店舗登録',
        titleKey: 'admin-order-mail-target-store-new',
        desc: ''
      }
    },
    {
      path: '/admin/order-mail-target-store/:storeCode',
      name: 'admin_order_mail_target_store_update',
      component: () => import('./views/admin/OrderMailTargetStoreRegist.vue'),
      meta: {
        title: '事前連絡店舗更新',
        titleKey: 'admin-order-mail-target-store-update',
        desc: ''
      }
    },

    
    {
      path: '/admin/csvUploadStore',
      name: 'admin/csvUploadStore',
      component: () => import('./views/admin/CsvUploadStore.vue'),
      meta: {
        title: '店舗CSVアップロード',
        titleKey: 'admin-csvUploadStore',
        desc: ''
      }
    },
    {
      path: '/admin/csvUploadItem',
      name: 'admin/csvUploadItem',
      component: () => import('./views/admin/CsvUploadItem.vue'),
      meta: {
        title: '商品CSVアップロード',
        titleKey: 'admin-csvUploadItem',
        desc: ''
      }
    },
    {
      path: '/admin/csvUploadInvoiceNumber',
      name: 'admin/csvUploadInvoiceNumber',
      component: () => import('./views/admin/CsvUploadInvoiceNumber.vue'),
      meta: {
        title: '送り状CSVアップロード',
        titleKey: 'admin-csvUploadInvoiceNumber',
        desc: ''
      }
    },
    {
      path: '/admin/csvUploadChibaReceiving',
      name: 'admin/csvUploadChibaReceiving',
      component: () => import('./views/admin/CsvUploadChibaReceiving.vue'),
      meta: {
        title: '千葉入荷CSVアップロード',
        titleKey: 'admin-csvUploadChibaReceiving',
        desc: ''
      }
    },
    {
      path: '/admin/csvUploadChibaDeliver',
      name: 'admin/csvUploadChibaDeliver',
      component: () => import('./views/admin/CsvUploadChibaDeliver.vue'),
      meta: {
        title: '千葉出荷CSVアップロード',
        titleKey: 'admin-csvUploadChibaDeliver',
        desc: ''
      }
    }

  ]
})
